module.exports = __webpack_public_path__ + "img/logo_footer.7125e19a.png";